// extracted by mini-css-extract-plugin
module.exports = {"pageFooterLinks":"page-footer-links-module--page-footer-links--2NuzL","btn":"page-footer-links-module--btn--1x8_r"};